/* src/app/pages/extra-pages/page401/page401.component.scss */
.container-fluid {
  align-items: center;
  background: #ff8c00;
  color: #fff;
  display: inline-block;
  height: 50%;
  padding: 1.5714286rem;
  text-align: center;
  vertical-align: middle;
  width: 100%;
}
h1 {
  font-size: 3.5rem;
  font-weight: 500;
  margin-top: 0;
  margin-bottom: 4.5rem;
  position: relative;
}
@media screen and (max-width: 767px) {
  h1 {
    margin-bottom: 6rem;
  }
}
h1:before {
  content: "\f29c";
  display: flex;
  font: normal normal normal 14px/1 FontAwesome;
  font-size: 26rem;
  justify-content: center;
  left: 0;
  line-height: 1;
  margin-top: -13rem;
  opacity: 0.2;
  position: absolute;
  right: 0;
  text-rendering: auto;
  top: 50%;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
@media screen and (max-width: 767px) {
  h1:before {
    font-size: 20rem;
    margin-top: -10rem;
  }
}
h5 {
  color: #000;
}
h2 {
  font-size: 2rem;
  font-weight: 500;
  margin-top: 0;
  margin-bottom: 0.5rem;
}
p {
  color: rgba(255, 255, 255, 0.5);
  margin: 0;
}
a {
  color: rgba(255, 255, 255, 0.7);
}
a:hover {
  color: #fff;
}
/*# sourceMappingURL=page401.component.css.map */
